module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-sad.531f9a9c.png";